module.exports = __webpack_public_path__ + "static/media/beep1.51d06191.mp3";